/**
 * VoiceRide Text-to-Speech utility
 * Uses Web Speech API (SpeechSynthesis) for voice feedback.
 */

const DEFAULT_LANG = 'de-DE';

export function speak(text, lang = DEFAULT_LANG) {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = lang;
  utterance.rate = 1.0;
  utterance.pitch = 1.0;
  utterance.volume = 1.0;

  // Try to pick a German voice if available
  const voices = window.speechSynthesis.getVoices();
  const langVoice = voices.find(v => v.lang.startsWith(lang.split('-')[0]));
  if (langVoice) utterance.voice = langVoice;

  window.speechSynthesis.speak(utterance);
}

export function speakPointSet(addressName, lang = DEFAULT_LANG) {
  speak(`Punkt gesetzt: ${addressName}`, lang);
}

export function speakDriverOnline(lang = DEFAULT_LANG) {
  speak('Du bist jetzt online. Warte auf Mitfahrer...', lang);
}

export function speakMatchFound(driverName, lang = DEFAULT_LANG) {
  speak(`Match gefunden: ${driverName}`, lang);
}

export default speak;
